export const DEMO_SETUP_START = 'DEMO_SETUP_START';
export const CREATE_DEMO_ORDER_SUCCESS = 'CREATE_DEMO_ORDER_SUCCESS';
export const CREATE_DEMO_ORDER_FAILURE = 'CREATE_DEMO_ORDER_FAILURE';
export const OPEN_EXISTING_DEMO_ORDER = 'OPEN_EXISTING_DEMO_ORDER';
export const SET_EXISTING_DEMO_ORDER = 'SET_EXISTING_DEMO_ORDER';
export const DEACTIVATE_DEMO_ORDER = 'DEACTIVATE_DEMO_ORDER';
export const DEACTIVATE_DEMO_ORDER_SUCCESS = 'DEACTIVATE_DEMO_ORDER_SUCCESS';
export const DEACTIVATE_DEMO_ORDER_FAILURE = 'DEACTIVATE_DEMO_ORDER_FAILURE';

export const demoSetupStart = (props) => {
  return {
    type: DEMO_SETUP_START,
    id: props.id,
    order: props.demoSetupData,
    shipFrom: props.demoShipFrom,
    setIsSettingUpTour: props.setIsSettingUpTour,
    demoProducts: props.demoProducts,
    demoTypes: props.demoTypes,
    tagData: props.tagData,
  };
};

export const createDemoOrderSuccess = (order, redirect, workflowGuid) => {
  return {
    type: CREATE_DEMO_ORDER_SUCCESS,
    order,
    redirect,
    workflowGuid,
  };
};

export const createDemoOrderFailure = (response, errorMessage, workflowGuid) => {
  return {
    type: CREATE_DEMO_ORDER_FAILURE,
    response,
    errorMessage,
    workflowGuid,
  };
};

export const openExistingDemoOrder = () => {
  return {
    type: OPEN_EXISTING_DEMO_ORDER,
  };
};

export const setExistingDemoOrder = (demoId) => {
  return {
    type: SET_EXISTING_DEMO_ORDER,
    data: demoId,
  };
};
export const deactivateDemoOrder = (props = {}) => {
  return {
    type: DEACTIVATE_DEMO_ORDER,
    demoProducts: props.products,
    demoTag: props.tagToDelete,
    demoShipFrom: props.shipFrom,
    demoFulfillmentPlanId: props.demoFulfillmentPlanId,
  };
};

export const deactivateDemoOrderSuccess = () => {
  return {
    type: DEACTIVATE_DEMO_ORDER_SUCCESS,
  };
};

export const deactivateDemoOrderFailure = () => {
  return {
    type: DEACTIVATE_DEMO_ORDER_FAILURE,
  };
};
